import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Switch } from '../components/ui/switch';
import { useTheme } from '../lib/theme';
import { useAuth } from '../lib/auth-context';
import { AppShell } from '../components/Layout';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import BrandSettingsCard from '../components/settings/BrandSettingsCard';
import { CookieConsentCard } from '../components/settings/CookieConsentCard';
import { PasswordChangeCard } from '../components/settings/PasswordChangeCard';
import { TrackingScriptsCard } from '../components/settings/TrackingScriptsCard';
import { PrivacyDataCard } from '../components/settings/PrivacyDataCard';

export default function SettingsPage() {
  const { theme, toggle } = useTheme();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <AppShell>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-6">
        <h1 className="text-3xl font-bold">Settings</h1>
        <Card className="border-border">
          <CardContent className="p-6 space-y-4">
            <h2 className="text-lg font-semibold">Profile</h2>
            <div className="text-sm">
              <p className="text-muted-foreground">Name</p>
              <p className="font-medium" data-testid="settings-user-name">{user?.name}</p>
            </div>
            <div className="text-sm">
              <p className="text-muted-foreground">Email</p>
              <p className="font-medium" data-testid="settings-user-email">{user?.email}</p>
            </div>
            <div className="text-sm">
              <p className="text-muted-foreground">Role</p>
              <Badge
                className={
                  user?.role === 'admin'
                    ? 'bg-primary text-primary-foreground font-mono-edge'
                    : user?.role === 'editor'
                    ? 'bg-[hsl(var(--sky))] text-foreground border border-border font-mono-edge'
                    : 'bg-secondary text-foreground border border-border font-mono-edge'
                }
                data-testid="settings-user-role"
              >
                {user?.role || 'viewer'}
              </Badge>
            </div>
          </CardContent>
        </Card>
        <Card className="border-border">
          <CardContent className="p-6">
            <h2 className="text-lg font-semibold mb-4">Preferences</h2>
            <div className="flex items-center justify-between">
              <div>
                <p className="font-medium">Dark mode</p>
                <p className="text-sm text-muted-foreground">Reduce glare in low light.</p>
              </div>
              <Switch checked={theme === 'dark'} onCheckedChange={toggle} data-testid="settings-dark-mode-switch" />
            </div>
          </CardContent>
        </Card>
        <PasswordChangeCard />
        <BrandSettingsCard />
        <TrackingScriptsCard />
        <CookieConsentCard />
        <PrivacyDataCard />
        <Card className="border-border">
          <CardContent className="p-6 flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold">Sign out</h2>
              <p className="text-sm text-muted-foreground">End your session on this device.</p>
            </div>
            <Button variant="destructive" onClick={() => { navigate('/'); setTimeout(() => logout(), 50); }} data-testid="settings-logout-button">
              <LogOut size={16} className="mr-2" /> Log out
            </Button>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
